import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { LegendComponent } from '@connect-services/client/components/legend/legend.component';
import { GroupedSource } from '@connect-services/client/components/legend/legend-list/legend-list.component';
import { MapFieldInterventionSource } from '@connect-services/client/components/map/map.component';
import { ExpansionPanelComponent } from '@connect-services/src/lib/components/expansion-panel/expansion-panel.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

enum LegendColorType {
    HIDDEN_ICON = 'gray-300',
    HIDDEN_TEXT = 'custom-extra-dark-grey',
    VISIBLE_ICON = 'secondary',
    VISIBLE_TEXT = 'black',
}

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ExpansionPanelComponent, LegendComponent, RessourcesModule],
    selector: 'app-legend-item',
    styleUrls: ['./legend-item.component.scss'],
    templateUrl: './legend-item.component.html',
})
export class LegendItemComponent {
    public readonly fieldInterventionSource = input<MapFieldInterventionSource | undefined>();
    public readonly groupedSource = input<GroupedSource | undefined>();

    protected readonly color = computed(() =>
        this.isGroupedSourceVisible() || this.isFieldInterventionSourceVisible()
            ? LegendColorType.VISIBLE_TEXT
            : LegendColorType.HIDDEN_TEXT,
    );

    protected readonly iconColor = computed(() =>
        this.isGroupedSourceVisible() || this.isFieldInterventionSourceVisible()
            ? LegendColorType.VISIBLE_ICON
            : LegendColorType.HIDDEN_ICON,
    );
    protected readonly isFieldInterventionSourceVisible = computed(() => !!this.fieldInterventionSource()?.isVisible);
    protected readonly isGroupedSourceVisible = computed(
        () => !!(this.groupedSource() && this.groupedSource()!.isActivated && this.groupedSource()!.isVisible),
    );
}
